import { render, staticRenderFns } from "./FormServer2Streamax.vue?vue&type=template&id=5b763978&scoped=true&"
import script from "./FormServer2Streamax.vue?vue&type=script&lang=ts&"
export * from "./FormServer2Streamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormServer2Streamax.vue?vue&type=style&index=0&id=5b763978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b763978",
  null
  
)

export default component.exports